var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import cx from 'clsx';
import { Card } from '../card/Card';
import { Inline } from '../inline/Inline';
import { Radio } from '../radio/Radio';
import { useRadioGroup } from '../radio_group/RadioGroup';
import { inputLabelStyles, radioStyles, wrapperCardVariants } from './RadioCard.css';
export const RadioCard = React.forwardRef(function RadioCard(_a, ref) {
    var { children, className, 'data-testid': dataTestId, id, label, value } = _a, rest = __rest(_a, ["children", "className", 'data-testid', "id", "label", "value"]);
    const { selectedValue } = useRadioGroup();
    const isSelected = selectedValue === value;
    return (_jsxs(Card, { className: cx(wrapperCardVariants[isSelected ? 'selected' : 'default'], className), children: [_jsx(Card.Section, { children: _jsx(Radio.Label, { className: inputLabelStyles, "data-testid": dataTestId, htmlFor: id, children: _jsxs(Inline, { alignY: "center", as: "span", noWrap: true, spacing: 16, children: [_jsx(Radio, Object.assign({}, rest, { className: radioStyles, id: id, ref: ref, value: value })), label] }) }) }), children] }));
});
